import { PRICE_INDEX_OZON_ONBOARDING_CLOSE_LIMIT } from './constants';

export type PriceIndexOzonOnboardingState = {
    closedCount: number;
    lastClosedAt: number | null;
};

export function parseOnboardingState(value: string | null): PriceIndexOzonOnboardingState {
    if (value === null) {
        return { closedCount: 0, lastClosedAt: null };
    }

    try {
        const state: unknown = JSON.parse(value);

        if (
            typeof state === 'object' &&
            state !== null &&
            'closedCount' in state &&
            typeof state.closedCount === 'number' &&
            Number.isInteger(state.closedCount) &&
            state.closedCount >= 0 &&
            'lastClosedAt' in state &&
            (state.lastClosedAt === null ||
                (typeof state.lastClosedAt === 'number' &&
                    Number.isFinite(state.lastClosedAt) &&
                    state.lastClosedAt >= 0))
        ) {
            return { closedCount: state.closedCount, lastClosedAt: state.lastClosedAt };
        }
    } catch {
        // Повреждённое значение не должно сбрасывать лимит показов.
    }

    return { closedCount: PRICE_INDEX_OZON_ONBOARDING_CLOSE_LIMIT, lastClosedAt: null };
}
